export enum NoteTypes {
    TaskNote = 1,
    AppointmentNote = 2,
    FinanceNote = 3,
    FinanceNoteReceived = 4,
    System = 5
}